import type { z } from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema
  .pick({
    id: true,
    payment: true,
  })
  .merge(
    zSchema
      .omit({
        id: true,
        number: true,
        status: true,
        cost: true,
        createdAt: true,
        services: true,
      })
      .partial(),
  );
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
